import { Button, Grid, Checkbox, FormControlLabel, makeStyles, Typography } from '@material-ui/core';
import React, { useState } from 'react'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useForm } from '../../../hooks/useForm';
import { Redirect } from 'react-router-dom';
import { CarouselImagen } from './CarouselImagen';
import { useDispatch } from 'react-redux';
import { FetchDataAfiliado, traerTurnoTeleconsulta, traerTurnosProximos } from '../../../actions/hce/hceTeleconsultaActions';
import { TIPO_TURNO } from '../../../utils/constants';
import { v4 as uuidv4 } from 'uuid';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "1rem",
  },
  submit: {
    marginTop: "1rem",
    textTransform: "none",
  },
  title: {
    fontWeight: "bold",
    fontStyle: "italic"
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  centerImage: {
    display: 'flex',
    justifyContent: 'center',
  },
  centeredImage: {
    maxWidth: '100%',
    height: 'auto',
  },
}));

const fecha = new Date();

export const SalaEspera = () => {

  const classes = useStyles();
  const dispatch = useDispatch();
  const [aceptoTerminos, setAceptoTerminos] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const initialState = {
    dni: "",
  };
  const [formValues, handleInputChange] = useForm(initialState);
  const { dni } = formValues;

  const connectionId = uuidv4();

  const handleLogin = (e) => {
    e.preventDefault();
    if (!aceptoTerminos) {
      alert('Debes aceptar los términos y condiciones antes de continuar.');
      return;
    }
    else {
      dispatch(traerTurnoTeleconsulta(dni, fecha, TIPO_TURNO.VIRTUAL, setRedirect, connectionId))
      dispatch(FetchDataAfiliado(dni))
      dispatch(traerTurnosProximos(dni, fecha))
    }
  }

  const sacarTurno = () => {
    const nuevaPestanaURL = 'http://www.ospedyc.org/telemedicina/sacar-turno.php';
    window.open(nuevaPestanaURL, '_blank');
  };

  const handleTermsClick = () => {
    const nuevaPestanaURL = 'https://www.ospedyc.org.ar/telemedicina/terminos.pdf';
    window.open(nuevaPestanaURL, '_blank');
  };

  // useEffect(() => {
  //    dispatch(clearDataAfiliado());
  //    dispatch(clearTurnoTeleconsulta());
  //    dispatch(clearTurnosProximos());
  // }, []);

  return (
    <React.Fragment>
      {redirect && (
        <Redirect
          to={{
            pathname: '/afiliado/salaesperaafiliado',
            state: {
              from: '/afiliado/salaespera',
            },
          }}
        />
      )}

      <Grid container justify='center' alignItems='center' spacing={1} style={{ padding: "2rem" }}>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
        >
          <ValidatorForm onSubmit={handleLogin}>
            <Grid
              justify="center"
              alignItems="center"
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: 'center' }}
            >
              <Typography align="center" variant="h4" color="primary" style={{ marginTop: "0.5rem" }}>
                OSPEDYC está donde vos estés.
              </Typography>
              <Typography align="center" variant="body2" color="secondary" style={{ marginTop: "0.5rem", fontSize: "1rem" }}>
                Nuestro servicio de telemedicina nos permite cuidarte desde cualquier lugar sin necesidad de esperas ni traslados.
              </Typography>
            </Grid>
            <Grid
              justify="center"
              alignItems="center"
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: 'center' }}
            >
              <TextValidator
                variant="outlined"
                margin="normal"
                fullWidth
                label="DNI"
                onChange={handleInputChange}
                name="dni"
                validators={[
                  "required",
                  "isNumber",
                  "maxNumber:99999999",
                  "minNumber:999999",
                ]}
                errorMessages={[
                  "Este campo es obligatorio",
                  "solo numeros",
                  "Verifique su dni",
                  "Verifique su dni",
                ]}
                value={dni}
                style={{ marginTop: "5rem" }}
              />
            </Grid>
            <Grid
              justify="center"
              alignItems="center"
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: 'center' }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    value="remember"
                    onChange={(e) => setAceptoTerminos(e.target.checked)}
                    checked={aceptoTerminos}
                    color="primary"
                  />
                }
                label={
                  <Typography variant="body2">
                    He leído y acepto los <span className={classes.link} onClick={handleTermsClick}>términos y condiciones</span>.
                  </Typography>
                }
              />
            </Grid>
            <Grid
              justify="center"
              alignItems="center"
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: 'center' }}
            >
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Ingresar
              </Button>
            </Grid>
            <Grid
              justify="center"
              alignItems="center"
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: 'center' }}
            >
              <Button
                type="button"
                fullWidth
                variant="outlined"
                color="primary"
                className={classes.submit}
                onClick={sacarTurno}
              >
                Sacar Turno
              </Button>
            </Grid>
            <Grid
              justify="center"
              alignItems="center"
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: 'center' }}
            >
              <Typography align="center" variant="body2" color="secondary" style={{ marginTop: "5rem", fontSize: "1rem" }}>
                ¿Qué necesitás? Para realizar la consulta médica online necesitás cualquier dispositivo móvil o computadora que cuente con cámara, audio y conectividad a internet.
              </Typography>
            </Grid>
          </ValidatorForm>

        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          style={{ alignSelf: 'center', paddingLeft: 1 }}
        >
          <CarouselImagen />
        </Grid>
      </Grid>

    </React.Fragment >
  )
}
